import FieldTemplate from './FieldTemplate.component';
import TextMode from './displayMode/TextMode.component';

export { FieldTemplate as DefaultModeTemplate, TextMode as TextModeTemplate };
export { TextMode };
export default FieldTemplate;
